import {
    Autocomplete,
    Box,
    Checkbox,
    FormControlLabel,
    Grid,
    Paper,
    TextField } from "../ui";
import ThreeDText from "../global/ThreeDText";
import {
  CART_INITIAL_STATE,
  formatDateInReact,
  formatDateInSnp,
  isEmpty,
  PayMedium,
  printDebugLog
} from "../../constants/constant";
import uiUtilInstance from "../../utilities/uiUtil";
import { Payments } from "../ui/icons";

const DialogSalary = ({
    employeeDetails,
    employeeSalary, setEmployeeSalary, fireSnackBarMsg }) => {


    const handleInputChange = (name, value) => {
        printDebugLog("handleInputChange", name, value);
        if (name === 'amount') {
            if (/^\d*\.?\d*$/.test(value)) {
                if (employeeSalary.payMedium === PayMedium.NOPAY) {
                    fireSnackBarMsg("Please select Payment methods", "center", "bottom", "#bc1c2b");
                } else if (employeeSalary.payMedium === PayMedium.ONLINE) {
                    const parseValue = Number(value) || 0.0;
                    if (parseValue > employeeDetails.totalOnlineBalance) {
                        fireSnackBarMsg("Exceeds Total Online Balance i.e " + employeeDetails.totalOnlineBalance, "center", "bottom", "#fa6607");
                    } else {
                        setEmployeeSalary(prev => ({
                            ...prev,
                            onlinePay: parseValue,
                            amount: value,
                        }));
                    }
                } else if (employeeSalary.payMedium === PayMedium.CASH) {
                    const parseValue = Number(value) || 0.0;
                    if (parseValue > employeeDetails.totalCashBalance) {
                        fireSnackBarMsg("Exceeds Total Cash Balance i.e " + employeeDetails.totalCashBalance, "center", "bottom", "#fa6607");
                    } else {
                        setEmployeeSalary(prev => ({
                            ...prev,
                            cashPay: parseValue,
                            amount: value,
                        }));
                    }
                } else {
                    const parseValue = Number(value) || 0.0;
                    let rt = parseValue / 2;
                    let mOnlinePay = 0.0;
                    let mCashPay = 0.0;
                    if (rt > employeeDetails.totalCashBalance) {
                        mOnlinePay = parseValue - employeeDetails.totalCashBalance;
                        if (mOnlinePay > employeeDetails.totalOnlineBalance) {
                            fireSnackBarMsg("You don't have enough balance", "center", "bottom", "#bc1c2b");
                            mOnlinePay = 0.0;
                        } else {
                            mCashPay = employeeDetails.totalCashBalance;
                        }
                    } else if (rt > employeeDetails.totalOnlineBalance) {
                        mCashPay = parseValue - employeeDetails.totalOnlineBalance;
                        if (mCashPay > employeeDetails.totalCashBalance) {
                            fireSnackBarMsg("You don't have enough balance", "center", "bottom", "#bc1c2b");
                            mCashPay = 0.0;
                        } else {
                            mOnlinePay = employeeDetails.totalOnlineBalance;
                        }
                    } else {
                        mCashPay = rt;
                        mOnlinePay = rt;
                    }
                    setEmployeeSalary(prev => ({
                        ...prev,
                        cashPay: mCashPay,
                        onlinePay: mOnlinePay,
                        amount: value,
                    }));
                }
            } else {
                setEmployeeSalary(prev => ({
                    ...prev,
                    cashPay: 0.0,
                    onlinePay: 0.0,
                    amount: value,
                }));
            }
        } else if (name === 'onlinePayChecked') {
            let mPayMedium;
            let mOnlineMedium = employeeSalary.onlinePayThrough;
            let mOnlinePay = 0.0;
            let mCashPay = 0.0;
            const rt = parseFloat(employeeSalary.amount) || 0.0;
            if (employeeSalary.payMedium === PayMedium.ONLINE) {
                mPayMedium = PayMedium.NOPAY;
                mOnlineMedium = "";
            } else if (employeeSalary.payMedium === PayMedium.CASH) {
                mPayMedium = PayMedium.BOTH;
                if (isEmpty(mOnlineMedium))
                    mOnlineMedium = CART_INITIAL_STATE.onlinePayMethod[0];
                mOnlinePay = rt / 2;
                if (mOnlinePay > employeeDetails.totalOnlineBalance) {
                    mOnlinePay = employeeDetails.totalOnlineBalance;
                    fireSnackBarMsg("Exceeds Total Online Balance i.e " + employeeDetails.totalOnlineBalance, "center", "bottom", "#fa6607");
                }
                mCashPay = rt - mOnlinePay;
                if (mCashPay > employeeDetails.totalCashBalance) {
                    mPayMedium = PayMedium.NOPAY;
                    mOnlineMedium = "";
                    mOnlinePay = 0.0;
                    mCashPay = 0.0;
                    fireSnackBarMsg("You don't have enough balance", "center", "bottom", "#bc1c2b");
                }
            } else if (employeeSalary.payMedium === PayMedium.BOTH) {
                mPayMedium = PayMedium.CASH;
                mOnlineMedium = "";
                mOnlinePay = 0.0;
                mCashPay = rt;
                if (mCashPay > employeeDetails.totalCashBalance) {
                    mPayMedium = PayMedium.NOPAY;
                    mCashPay = 0.0;
                    fireSnackBarMsg("You don't have enough balance " + employeeDetails.totalCashBalance, "center", "bottom", "#bc1c2b");
                }
            } else {
                mPayMedium = PayMedium.ONLINE;
                mOnlinePay = rt;
                if (mOnlinePay > employeeDetails.totalOnlineBalance) {
                    mOnlineMedium = "";
                    mOnlinePay = employeeDetails.totalOnlineBalance;
                    fireSnackBarMsg("You don't have enough balance " + employeeDetails.totalOnlineBalance, "center", "bottom", "#fa6607");
                } else
                    mOnlineMedium = CART_INITIAL_STATE.onlinePayMethod[0];
            }
            setEmployeeSalary(prev => ({
                ...prev,
                payMedium: mPayMedium,
                onlinePayThrough: mOnlineMedium,
                onlinePay: mOnlinePay,
                cashPay: mCashPay,
            }));
        } else if (name === 'cashPayChecked') {
            let mPayMedium;
            let mOnlineMedium = employeeSalary.onlinePayThrough;
            let mOnlinePay = 0.0;
            let mCashPay = 0.0;
            const rt = parseFloat(employeeSalary.amount) || 0.0;
            if (employeeSalary.payMedium === PayMedium.ONLINE) {
                mPayMedium = PayMedium.BOTH;
                if (isEmpty(mOnlineMedium))
                    mOnlineMedium = CART_INITIAL_STATE.onlinePayMethod[0];
                mCashPay = rt / 2;
                if (mCashPay > employeeDetails.totalCashBalance) {
                    mCashPay = employeeDetails.totalCashBalance;
                    fireSnackBarMsg("Exceeds Total Cash Balance i.e " + employeeDetails.totalCashBalance, "center", "bottom", "#fa6607");
                }
                mOnlinePay = rt - mCashPay;
                if (mOnlinePay > employeeDetails.totalOnlineBalance) {
                    mPayMedium = PayMedium.NOPAY;
                    mOnlineMedium = "";
                    mOnlinePay = 0.0;
                    mCashPay = 0.0;
                    fireSnackBarMsg("You don't have enough balance", "center", "bottom", "#bc1c2b");
                }
            } else if (employeeSalary.payMedium === PayMedium.CASH) {
                mPayMedium = PayMedium.NOPAY;
            } else if (employeeSalary.payMedium === PayMedium.BOTH) {
                mPayMedium = PayMedium.ONLINE;
                mOnlinePay = rt;
                if (mOnlinePay > employeeDetails.totalOnlineBalance) {
                    mOnlineMedium = "";
                    mPayMedium = PayMedium.NOPAY;
                    fireSnackBarMsg("You don't have enough balance " + employeeDetails.totalOnlineBalance, "center", "bottom", "#bc1c2b");
                } else
                    mOnlineMedium = CART_INITIAL_STATE.onlinePayMethod[0];
            } else {
                mPayMedium = PayMedium.CASH;
                mCashPay = rt;
                if (mCashPay > employeeDetails.totalCashBalance) {
                    mCashPay = 0.0;
                    mPayMedium = PayMedium.NOPAY;
                    fireSnackBarMsg("You don't have enough balance " + employeeDetails.totalCashBalance, "center", "bottom", "#bc1c2b");
                }
            }
            setEmployeeSalary(prev => ({
                ...prev,
                payMedium: mPayMedium,
                onlinePayThrough: mOnlineMedium,
                cashPay: mCashPay,
                onlinePay: mOnlinePay,
            }));
        } else if (name === 'onlinePayAmt') {
            if (value === '' || /^\d*\.?\d*$/.test(value)) { // Allow empty string or numeric values
                const rt = parseFloat(employeeSalary.amount) || 0.0;
                const parsedOnlineAmt = parseFloat(value) || 0.0;
                if (parsedOnlineAmt > rt) {
                    fireSnackBarMsg("Exceeds Amount i.e " + rt, "center", "bottom", "#bc1c2b");
                } else {
                    if (parsedOnlineAmt <= employeeDetails.totalOnlineBalance) {
                        const mCashPay = employeeSalary.payMedium === PayMedium.ONLINE ? 0.0 : rt - parsedOnlineAmt;
                        if (employeeSalary.payMedium === PayMedium.CASH &&
                            mCashPay > employeeDetails.totalCashBalance
                        ) {
                            fireSnackBarMsg("Exceeds Total Cash Balance i.e " + employeeDetails.totalCashBalance, "center", "bottom", "#bc1c2b");
                        } else {
                            setEmployeeSalary(prev => ({
                                ...prev,
                                onlinePay: value,
                                cashPay: mCashPay,
                            }));
                        }
                    } else {
                        fireSnackBarMsg("Exceeds Total Online Balance i.e " + employeeDetails.totalOnlineBalance, "center", "bottom", "#bc1c2b");
                    }
                }

            }
        } else if (name === 'cashPayAmt') {
            if (value === '' || /^\d*\.?\d*$/.test(value)) { // Allow empty string or numeric values
                const rt = parseFloat(employeeSalary.dues) || 0.0;
                const parsedCashAmt = parseFloat(value) || 0.0;
                if (parsedCashAmt > rt) {
                    fireSnackBarMsg("Exceeds Purchase Amount i.e " + rt, "center", "bottom", "#bc1c2b");
                } else {
                    if (parsedCashAmt <= employeeDetails.totalCashBalance) {
                        const mOnlinePay = employeeSalary.payMedium === PayMedium.CASH ? 0.0 : rt - parsedCashAmt;
                        if (employeeSalary.payMedium === PayMedium.ONLINE &&
                            mOnlinePay > employeeDetails.totalOnlineBalance
                        ) {
                            fireSnackBarMsg("Exceeds Total Online Balance i.e " + employeeDetails.totalOnlineBalance, "center", "bottom", "#bc1c2b");
                        } else {
                            setEmployeeSalary(prev => ({
                                ...prev,
                                cashPay: value,
                                onlinePay: mOnlinePay,
                            }));
                        }
                    } else {
                        fireSnackBarMsg("Exceeds Total Cash Balance i.e " + employeeDetails.totalCashBalance, "center", "bottom", "#bc1c2b");
                    }
                }
            }
        }
    }
    return (
        <Paper elevation={6} sx={{ p: 3, borderRadius: 4, bgcolor: '#f9e5e1' }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ThreeDText
                        text={employeeDetails.details}
                        display=""
                        className="three-d-text-container"
                        justifyContent="left"
                        alignItems="left" />
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <TextField
                        type="date"
                        id="startDate"
                        name="startDate"
                        variant="filled"
                        size="small"
                        label="Select Paid Date(Optional)"
                        value={formatDateInReact(employeeSalary.paidOn)}
                        onChange={(event) => {
                            const formatDateVal = formatDateInSnp(event.target.value, employeeSalary.paidOn);
                            setEmployeeSalary(prev => ({
                                ...prev,
                                paidOn: formatDateVal,
                            }))
                        }}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            inputProps: {
                                max: formatDateInReact(uiUtilInstance.todayFormattedDate),
                            },
                        }} />
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <TextField
                        required
                        id="amount"
                        name="amount"
                        variant="filled"
                        size="small"
                        label="Enter Amount"
                        fullWidth
                        value={employeeSalary.amount}
                        onChange={(event) => handleInputChange("amount",event.target.value)}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={6} xs={12}>
                    <TextField
                        id="message"
                        variant="filled"
                        size="small"
                        label="Enter Message"
                        name="message"
                        defaultValue={employeeSalary.message}
                        onChange={(e) => setEmployeeSalary({
                            ...employeeSalary, message: e.target.value,
                        })}
                        multiline={true}
                        rows={3}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <ThreeDText
                        text="Payment Information"
                        display=""
                        className="three-d-text-container"
                        justifyContent="left"
                        alignItems="left" />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        name="onlinePayChecked"
                        checked={employeeSalary.payMedium === PayMedium.ONLINE || employeeSalary.payMedium === PayMedium.BOTH}
                        control={<Checkbox />} label="Online" onChange={()=> handleInputChange("onlinePayChecked",Payments.ONLINE)} />
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <Autocomplete
                        id="online-select"
                        options={CART_INITIAL_STATE.onlinePayMethod}
                        autoHighlight
                        variant="filled"
                        size="small"
                        fullWidth
                        disabled={employeeSalary.payMedium === PayMedium.NOPAY || employeeSalary.payMedium === PayMedium.CASH}
                        isOptionEqualToValue={(option, value) => {
                            if (!option) return false;
                            if (!value) return false;
                            return (option === value);
                        }}
                        style={{ width: "70%", maxHeight: "20%" }}
                        onChange={(e, option) => handleInputChange("online-select", option)}
                        getOptionLabel={(option) => option ?? ''}
                        value={employeeSalary.onlinePayThrough}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                {...props}
                            >
                                {option}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search Online Pay Method"
                                inputProps={{
                                    ...params.inputProps,
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <TextField
                        id="onlinePayAmt"
                        name="onlinePayAmt"
                        variant="filled"
                        size="small"
                        label="Enter Online Amount"
                        value={employeeSalary.onlinePay}
                        disabled={employeeSalary.payMedium !== PayMedium.BOTH}
                        onChange={(e) => handleInputChange('onlinePayAmt', e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <FormControlLabel
                        name="cashPayChecked"
                        checked={employeeSalary.payMedium === PayMedium.CASH || employeeSalary.payMedium === PayMedium.BOTH} 
                        control={<Checkbox />} label="Cash" onChange={() => handleInputChange('cashPayChecked', PayMedium.CASH)} />
                </Grid>

                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <TextField
                        id="cashPayAmt"
                        name="cashPayAmt"
                        variant="filled"
                        size="small"
                        disabled={employeeSalary.payMedium !== PayMedium.BOTH}
                        style={{ width: "70%" }}
                        label="Enter Cash Amount"
                        value={employeeSalary.cashPay}
                        onChange={(e) => handleInputChange('cashPayAmt', e.target.value)}
                    />
                </Grid>

            </Grid>
        </Paper>
    )
}
export default DialogSalary;